declare var swal: any;
import { Component, OnInit,Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { ActorDashBoardProfileSummaryInfoRequest, DashBoardProfileSummaryController } from '../../../../../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';

declare var require: any;


import * as alertFunctions from '../../../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../../../animations/router.animations';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PatientInfoByFormattedCodeRequest, PatientInfoByFormattedCodeController, TreatmentCyclesController, TreatmentCyclesRequest, IvfWorkbenchController, IvfWorkbenchRequest, CounsellingActivitiesByTimeController, CounsellingActivitiesByTimeRequest, IvfTreatmentPlanController, IvfTreatmentPlanRequest, FollicularScanDetailController, FollicularScanDetailRequest, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, TreatmentCycleActiityMasterController, IvfCycleActivityMasterRequest, SaveIvfCycleMedicineDataRequest, DeleteCycleActivityRequest, GenericProcPostRequest, S_Methods, DeleteCycleMedicineOrTestRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbEventAddModal } from '../TreatmentCycle/eventadd.modal';
import { ActivitesPipe, MedicinePipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { NgbEditScanMedicineModal } from './editscanmedicine.modal';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
//import { NgbAddNewPatient } from './modal/addnewpatient.modal';





@Component({
  selector: 'medicineview',
    templateUrl: './medicineview.component.html',
  styleUrls: [
    './medicineview.component.scss']
  ,animations: [routerTransition()]
})

export class MedicineViewComponent implements OnInit {
  
  
  GetActorIdentitiesController(): any {
    throw new Error("Method not implemented.");
  }
    @Input() ActorCode: number;
    @Input() CycleCode: number;
    @Input() LMPDate: Date;
  @Input() Title: string;
  @Input() SourceType: string;
    //@Input() Index: number = 1;
  //public ActorCode: number = 0;
    public FormattedCode: number = 0;
    public index: number = 1;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public Showarrow: boolean = false;
  public Showrow: boolean = true;
  public ShowPatientDetails: boolean = false;
  public Showivfbench: boolean = true;
  public ScanDetails: boolean = false;
  public PickUpDetails: boolean = false;
  public ETDetails: boolean = false;
  public SADetails: boolean = false;
  public InseminationDetails: boolean = false;
  public OQADetails: boolean = false;
  public GradingDetails: boolean = false;
    public FreezingDetails: boolean = false;
    public EggSourceActorCode: number;
  searchTitle: string;
  public isRequesting: boolean = false;
  CurrentIsSessionExistsRequest: IsSessionExistsRequest;
    public ApiResData: ApiResponseModel;
    public ScanDate: Date;

    CurrentFollicularScanDetailController: FollicularScanDetailController[];
    FollicularScanEndInfo: FollicularScanDetailController;
    CurrentFollicularScanDetailRequest: FollicularScanDetailRequest;

    LoadScansData() {
        //alert("ScansData")
        this.CurrentFollicularScanDetailRequest = new FollicularScanDetailRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentFollicularScanDetailRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetFollicularScanDetailController();
    }

    GetFollicularScanDetailController() {
        this.StartRefreshing();
        this.CurrentFollicularScanDetailRequest.ConditionalOperator = 20;
        this.CurrentFollicularScanDetailRequest.ScanCode = 0;
        this.CurrentFollicularScanDetailRequest.CycleCode = this.CycleCode;
        this.CurrentFollicularScanDetailRequest.PatientCode = 0;

        //alert(this.FormattedCode);
        this.actorservice.GetFollicularScanDetailController(this.CurrentFollicularScanDetailRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentFollicularScanDetailController = this.ApiResData.Result;
                    this.FollicularScanEndInfo = this.CurrentFollicularScanDetailController[0];
                    this.ScanDate = this.CurrentFollicularScanDetailController[0].ScanDate;

                    //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
                    //  = this.FollicularScanEndInfo.EndometriumThickness;
                    //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
                    //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    this.stopRefreshing();
                    this.LoadPatients();
                    //   this.LoadGuardian();
                    //this.LoadMessages();

                    //this.LoadOvaryData();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
    SelectedTreatmentCycle: TreatmentCyclesByActorCodeController;
  CurrentSaveIvfCycleMedicineDataRequest: SaveIvfCycleMedicineDataRequest;
    CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
    LoadPatients() {
        this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
        this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = this.ActorCode;
        this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
        this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetTreatmentCyclesByActorCodeController();
    }

    GetTreatmentCyclesByActorCodeController() {
        this.StartRefreshing();


        this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
                    this.SelectedTreatmentCycle = this.CurrentTreatmentCyclesByActorCodeController[0];
                    //this.LMPDate = this.SelectedTreatmentCycle.LMP;
                    this.EggSourceActorCode = this.CurrentTreatmentCyclesByActorCodeController[0].EggActorCode;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    this.stopRefreshing();
                    //this.LoadPlan();
                    this.LoadMasterReq();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentTreatmentCycleActiityMasterController: TreatmentCycleActiityMasterController[];
    ActivityCodeInfo: TreatmentCycleActiityMasterController;
    CurrentIvfCycleActivityMasterRequest: IvfCycleActivityMasterRequest;

    LoadMasterReq() {
        //alert("ScansData")
        this.CurrentIvfCycleActivityMasterRequest = new IvfCycleActivityMasterRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfCycleActivityMasterRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetTreatmentCycleActiityMasterController();
    }

    GetTreatmentCycleActiityMasterController() {
        this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
        //this.CurrentIvfCycleActivityMasterRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
        //this.CycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
        this.CurrentIvfCycleActivityMasterRequest.TreatmentCycle = this.CycleCode;
        this.CurrentIvfCycleActivityMasterRequest.ConditionalOperator = 10;
        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        //this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
        //alert(this.FormattedCode);
        this.actorservice.GetTreatmentCycleActiityMasterController(this.CurrentIvfCycleActivityMasterRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentTreatmentCycleActiityMasterController = this.ApiResData.Result;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    this.stopRefreshing();
                    this.LoadMedicineData();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    //this.GetCycleActivity(this.ActorCode, this.ScanDate);

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    GetCycleActivity(ActorCode: number, ScanDate: Date): TreatmentCycleActiityMasterController[] {
        //alert(ActorCode);
        //alert(ScanDate);
        return this.CurrentTreatmentCycleActiityMasterController.filter(
            function (v, i, d) {

                return v.ActorID == ActorCode && v.DocDate == ScanDate;
            }
        )

    }
    CurrentIvfCycleMedicineByCodeController: IvfCycleMedicineByCodeController[];
    CurrentIvfCycleMedicineByCodeRequest: IvfCycleMedicineByCodeRequest;

    LoadMedicineData() {
        //alert("ScansData")
        this.CurrentIvfCycleMedicineByCodeRequest = new IvfCycleMedicineByCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfCycleMedicineByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.pdata = this.CurrentIvfCycleMedicineByCodeController;
        this.GetIvfCycleMedicineByCodeController();
    }

    GetIvfCycleMedicineByCodeController() {
        this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.CurrentIvfCycleMedicineByCodeRequest.CycleCode = this.CycleCode;
        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        this.CurrentIvfCycleMedicineByCodeRequest.ActorCode = this.ActorCode;
        this.CurrentIvfCycleMedicineByCodeRequest.ConditionalOperator = 10;
        this.CurrentIvfCycleMedicineByCodeRequest.ActivityCode = 0;
        //alert(this.FormattedCode);
        this.actorservice.GetIvfCycleMedicineByCodeController(this.CurrentIvfCycleMedicineByCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentIvfCycleMedicineByCodeController = this.ApiResData.Result;
                    this.pdata = this.CurrentIvfCycleMedicineByCodeController;
                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
  sub: Subscription;
  constructor(private router: Router,
    private loaderService: SpinnerService,
    private hcpservice: HCPService,
    private actorservice: ActorService,
    private modalService: NgbModal,
      private route: ActivatedRoute,
    private filter: MedicinePipe,
    private tosterservice: NGXToastrService,
    private loginservice: LoginService) { }

  ngOnInit() {

    //this.DisplaySelfOROthers();
    //this.GetPatientInfoByFormattedCodeController();
      //this.LoadPlan();
      //this.LoadScansData();
    this.LoadMedicineData();
    this.CurrentSaveIvfCycleMedicineDataRequest = new SaveIvfCycleMedicineDataRequest();
    this.CurrentSaveIvfCycleMedicineDataRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  }
  public DisplaySelf: boolean = true;
  public DisplayOthers: boolean = false;
  DisplaySelfOROthers() {
    if (this.SourceType == 'Self') {
      this.DisplaySelf == true;
      this.DisplayOthers == false;
      this.LoadMedicineData();
    }
    else {
      this.DisplaySelf == false;
      this.DisplayOthers == true;
      this.LoadMedicineData();
    }
  }

  EditMedicine(l: IvfCycleMedicineByCodeController) {
    this.CurrentSaveIvfCycleMedicineDataRequest.ActorCode = l.ActorCode;
    this.CurrentSaveIvfCycleMedicineDataRequest.ActivityCode = l.CycleActivity;
    this.CurrentSaveIvfCycleMedicineDataRequest.CycleCode = this.CycleCode;
    this.CurrentSaveIvfCycleMedicineDataRequest.StartDate = l.StartDate;
    this.CurrentSaveIvfCycleMedicineDataRequest.EndDate = l.EndDate;
    this.CurrentSaveIvfCycleMedicineDataRequest.ClinicalOrderItem = l.ClinicalOrderItem;
    this.CurrentSaveIvfCycleMedicineDataRequest.CycleMedicineCode = l.CycleMedicineCode;
    this.CurrentSaveIvfCycleMedicineDataRequest.ConditionalOperator = 20;
    this.CurrentSaveIvfCycleMedicineDataRequest.Objective = l.Objective;
    this.CurrentSaveIvfCycleMedicineDataRequest.Dose = l.Dosage;
    this.CurrentSaveIvfCycleMedicineDataRequest.DurationType = l.DurationType;
    this.CurrentSaveIvfCycleMedicineDataRequest.ConditionalOperator = 20;
    this.CurrentSaveIvfCycleMedicineDataRequest.Form = l.DosageForm;
    this.CurrentSaveIvfCycleMedicineDataRequest.Instructions = l.MedicineInstructions;
    this.CurrentSaveIvfCycleMedicineDataRequest.MedicineCode = l.MedicineCode;
    this.CurrentSaveIvfCycleMedicineDataRequest.MedicineName = l.MedicineName;
    this.CurrentSaveIvfCycleMedicineDataRequest.RecordStatus = l.RecordStatus;
    this.CurrentSaveIvfCycleMedicineDataRequest.Remarks = l.MedicineInstructions;
    this.CurrentSaveIvfCycleMedicineDataRequest.Duration = l.Duration;

    const modalRef = this.modalService.open(NgbEditScanMedicineModal,
      {
        centered: true,
        keyboard: false,
        backdrop: 'static'

      })
    modalRef.componentInstance.CurrentSaveIvfCycleMedicineDataRequest = this.CurrentSaveIvfCycleMedicineDataRequest;
    modalRef.componentInstance.TcModelName = this.SelectedTreatmentCycle.TCModelName;
    modalRef.result.then(x => { this.GetIvfCycleMedicineByCodeController() })
  }

  ShowList: boolean = true;
  delMedicine(l: any) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {
      this.DeleteActorIdentitiesMedicine(l);
    }, function (dismiss) {
    if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  DeleteActorIdentitiesMedicine(l: any) {
    var item2 = l as IvfCycleMedicineByCodeController;
    console.log('..................');
    this.CurrentSaveIvfCycleMedicineDataRequest.ConditionalOperator = 30;
    this.CurrentSaveIvfCycleMedicineDataRequest.MedicineCode = item2.MedicineCode;
    this.CurrentSaveIvfCycleMedicineDataRequest.CycleMedicineCode = item2.CycleMedicineCode;
    this.CurrentSaveIvfCycleMedicineDataRequest.ActivityCode = item2.CycleActivity;
    this.CurrentSaveIvfCycleMedicineDataRequest.CycleCode = this.CycleCode;
    this.CurrentSaveIvfCycleMedicineDataRequest.ActorCode = this.ActorCode;
    this.actorservice.SaveIvfCycleMedicineData(this.CurrentSaveIvfCycleMedicineDataRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          if (this.ApiResData.Result > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
            this.LoadMedicineData();
          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }
      },
        (error) => {
          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }
      );
  }
  
  //criteriaChange(value: any) {
   
  //}
  BackToProfile() {
    this.ShowList = true;
    this.ShowPatientDetails = false;
    this.Showarrow = false;
  }
  
 
  clearData() {
    this.isNew = true;
    this.ShowList = false;

  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }
  display(l: IvfWorkbenchController) {
    if (l.Name == "Scans") {
      this.router.navigate(['healins/ivfscans']);
    }
    else if (l.Name == "Ready for Pickup" || l.Name == "PickUps") {
      this.router.navigate(['healins/ivfpickups']);
    }
    else if (l.Name == "Oocyte Quality Assessment") {
      this.router.navigate(['healins/ivfoqa']);
    }
    else if (l.Name == "Insemination") {
      this.router.navigate(['healins/ivfinsemination']);
    }
    else if (l.Name == "EmbryoGrading") {
      this.router.navigate(['healins/ivfembryograding']);
    }
    else if (l.Name == "ReadyForTransfer") {
      this.router.navigate(['healins/ivffreezing']);
    }
    else if (l.Name == "FET Grading") {

    }
    else if (l.Name == "Calander") {

    }
    else if (l.Name == "") {

    }
}
  displayscans() {
    //this.Showivfbench = false;
    //this.ScanDetails = true;
    this.router.navigate(['healins/ivfscans']);
  }
  displaypickup() {
    //this.Showivfbench = false;
    //this.PickUpDetails = true;
    this.router.navigate(['healins/ivfpickups']);
  }
  displayet() {
    //this.Showivfbench = false;
    //this.ETDetails = true;
    this.router.navigate(['healins/ivfembryotransfer']);
  }
  displaysa() {
    //this.Showivfbench = false;
    //this.SADetails = true;
    this.router.navigate(['healins/ivfsemen']);
  }
  displayinsemination() {
    //this.Showivfbench = false;
    //this.InseminationDetails = true;
    this.router.navigate(['healins/ivfinsemination']);
  }
  displayoqa() {
    //this.Showivfbench = false;
    //this.OQADetails = true;
    this.router.navigate(['healins/ivfoqa']);
  }
  displaygrading() {
    //this.Showivfbench = false;
    //this.GradingDetails = true;
    this.router.navigate(['healins/ivfembryograding']);
  }
  displayfreezing() {
    //this.Showivfbench = false;
    //this.FreezingDetails = true;
    this.router.navigate(['healins/ivffreezing']);
  }
  //AddNewPatient() {
    
  //  const modalRef = this.modalService.open(NgbAddNewPatient,
  //    {
  //      centered: true,
  //      size: "lg",
  //      backdrop: 'static',
  //      keyboard: false
  //    })
  //  modalRef.componentInstance.ActorCode = this.ActorCode;
  //  //modalRef.componentInstance.ActorCode = this.ActorCode;
  //  modalRef.result.then(x => { this.GetPatientInfoByFormattedCodeController() })

  //}
  CancelNewOperation() {
    
    this.ShowList = true;
  }

  ///////////
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

 
  gotoprofile() {
    this.router.navigate(['testnurse/profile']);

  }
     pdata: any[];// = this.data;
    listFilter: string;
    ngOnChanges(changes: any) {
        if (JSON.stringify(changes).indexOf("data") != -1)
            this.pdata = this.CurrentIvfCycleMedicineByCodeController;

        this.criteriaChange(this.listFilter);
    }
    criteriaChange(value: any) {
        if (this.filter != null) {
            if (value != '[object Event]') {
                this.listFilter = value;
                //alert(this.listFilter);
                this.pdata = this.filter.transform(this.CurrentIvfCycleMedicineByCodeController,
                    this.listFilter);
            }
        }
    }

  //SelectedPatient: PatientInfoByFormattedCodeController;
  //ViewPatientDetails(objCategory: any) {
  //  var patient: PatientInfoByFormattedCodeController = objCategory;

  //  if (patient != null) {

      
      
  //    this.ShowPatientDetails = true;
  //    this.ShowList = false;
  //    this.SelectedPatient = patient;
  //    this.Showarrow = true;
  //    this.Showrow = false;
  //    //this.LoadPatientdetails()
     
  //  }
  //  else {
  //    this.ShowPatientDetails = false;
  //  }
  //}
  //SelectedPatientDetailsController: PatientInfoByFormattedCodeController;
  //SelectedPatientDetailsRequest: PatientInfoByFormattedCodeRequest;
  //LoadPatientdetails() {
   
   
  //  this.SelectedPatientDetailsRequest = new PatientInfoByFormattedCodeRequest();
   
  //  this.SelectedPatientDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  this.SelectedPatientDetailsRequest.FormattedCode = this.SelectedPatient.ActorCode.toString();// AppData.Instance().UserLoginDetails.FacilityActorCode;
  //  this.GetPatientInfoByFormattedCodeController();
  //}
  SelectedPatient: TreatmentCyclesController;
  ViewPatientDetails(objCategory: any) {
    var patient: TreatmentCyclesController = objCategory;
    if (patient != null) {
      this.SelectedPatient = null;
      this.SelectedPatient = patient;
      this.ShowList = false;
      this.ShowPatientDetails = true;
      this.Showarrow = false;
      this.Showrow = false;
      //this.ShowData = false;
      
    }
    else {
     
    }
    
  }
   

 

}
